import {
	apiAxios
} from '../axios'

import Europess from '../wangZhi'
let Europe = Europess + '/client/'

export default {
	// 获取分类栏目 
	getShopGroup: data => apiAxios('post', Europe + "getShopGroup", data),
	// 网站Banner列表 
	getShopBanner: data => apiAxios('post', Europe + "getShopBanner", data),
	// 个性化商品推荐(注释参照商品搜索) 
	getPersonalizedGoods: data => apiAxios('post', Europe + "getPersonalizedGoods", data),
	// 普通商品推荐(注释参照分类栏目和商品搜索) 
  getRecommendedGoods: data => apiAxios('post', Europe + "getRecommendedGoods", data),
  // 获取热销品类
  getHotSaleClass: data => apiAxios('post', Europe + "getHotSaleClass", data),
  // 获取热销商品
  getHotSaleGoods: data => apiAxios('post', Europe + "getHotSaleGoods", data),
  // 获取根据您的喜好推荐商品
  getHotSaleRecommend: data => apiAxios('post', Europe + "getHotSaleRecommend", data),
  // 首页平台自营
  getHomeSelfSupportGoods: data => apiAxios('post', Europe + "getHomeSelfSupportGoods", data),
  // 自营商品分类列表
  getSelfSupportClass: data => apiAxios('post', Europe + "getSelfSupportClass", data),
  // 自营商品列表
  getSelfSupportGoods: data => apiAxios('post', Europe + "getSelfSupportGoods", data),
  // 首页推荐关键词
  getHomeKeyWords: data => apiAxios('post', Europe + "getHomeKeyWords", data),
 
}